export default {"document":"GcV72G_document",}